/**
 * EMOTO Dealer Plan Application Page Controller
 * assets/emoto-dealer-page.js
 */
(function() {
  'use strict';

  function initDealerForm() {
    const form = document.getElementById('emoto-dealer-form');
    if (!form) return;

    const submitBtn = document.getElementById('emoto-dealer-submit-btn');
    const alertBox = document.getElementById('emoto-dealer-alert');
    const successContainer = document.getElementById('emoto-dealer-success');
    const formFieldsContainer = document.getElementById('emoto-dealer-form-fields');

    const apiBase = window.EMOTO_API_BASE || 'https://emoto-marketplace-app.vercel.app';
    const endpoint = form.getAttribute('data-api-endpoint') || (apiBase + '/api/dealers');

    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      if (alertBox) {
        alertBox.style.display = 'none';
        alertBox.textContent = '';
      }

      // Fields
      const dealershipName = document.getElementById('dealership-name');
      const yourName = document.getElementById('your-name');
      const email = document.getElementById('dealer-email');
      const phone = document.getElementById('dealer-phone');
      const cityState = document.getElementById('city-and-state');
      const website = document.getElementById('dealer-website');
      const usedUnits = document.getElementById('used-units-on-hand');
      const mostly = document.getElementById('dealer-mostly');
      const notes = document.getElementById('dealer-notes');

      // Clear existing errors
      [dealershipName, yourName, email, phone, cityState, usedUnits, mostly].forEach(input => {
        if (input) input.classList.remove('has-error');
      });

      // Validation
      const errors = [];
      if (!dealershipName || !dealershipName.value.trim()) {
        errors.push('Dealership name is required');
        if (dealershipName) dealershipName.classList.add('has-error');
      }
      if (!yourName || !yourName.value.trim()) {
        errors.push('Your name is required');
        if (yourName) yourName.classList.add('has-error');
      }
      if (!email || !email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
        errors.push('A valid email address is required');
        if (email) email.classList.add('has-error');
      }
      if (!phone || !phone.value.trim()) {
        errors.push('Phone number is required');
        if (phone) phone.classList.add('has-error');
      }
      if (!cityState || !cityState.value.trim()) {
        errors.push('City and state is required');
        if (cityState) cityState.classList.add('has-error');
      }
      if (!usedUnits || !usedUnits.value.trim()) {
        errors.push('Used units count is required');
        if (usedUnits) usedUnits.classList.add('has-error');
      }
      if (!mostly || !mostly.value.trim()) {
        errors.push('Inventory focus type is required');
        if (mostly) mostly.classList.add('has-error');
      }

      if (errors.length > 0) {
        if (alertBox) {
          alertBox.textContent = errors[0];
          alertBox.style.display = 'flex';
          alertBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        return;
      }

      const payload = {
        dealership_name: dealershipName.value.trim(),
        your_name: yourName.value.trim(),
        email: email.value.trim(),
        phone: phone.value.trim(),
        city_and_state: cityState.value.trim(),
        website: website ? website.value.trim() : '',
        used_units_on_hand: usedUnits.value.trim(),
        mostly: mostly.value.trim(),
        notes: notes ? notes.value.trim() : ''
      };

      // Loading state
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span class="emoto-dealer-spinner"></span> Sending inquiry...';
      }

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        const data = await response.json();

        if (response.ok && data.success) {
          // Success State
          if (formFieldsContainer) {
            formFieldsContainer.style.display = 'none';
          }
          if (successContainer) {
            successContainer.style.display = 'flex';
            const nameSpan = document.getElementById('emoto-success-dealer-name');
            if (nameSpan) {
              nameSpan.textContent = payload.dealership_name;
            }
            successContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } else {
          throw new Error(data.error || 'Failed to submit dealer inquiry. Please try again.');
        }
      } catch (err) {
        console.error('[Dealer Application Error]', err);
        if (alertBox) {
          alertBox.textContent = err.message || 'Something went wrong. Please check your connection or call us directly.';
          alertBox.style.display = 'flex';
          alertBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = "Send — we'll call you";
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDealerForm);
  } else {
    initDealerForm();
  }
})();
